import './i18n';
import { currentLang } from './i18n';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntdApp } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import enUS from 'antd/locale/en_US';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import 'antd/dist/reset.css';
import './index.css';
import './styles/responsive.css';
import App from './App';

// Set dayjs locale based on detected language
if (currentLang === 'zh') {
  dayjs.locale('zh-cn');
}

// Theme configuration
const theme = {
  token: {
    colorPrimary: '#0ea5e9',
    borderRadius: 6,
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  },
};

const antdLocale = currentLang === 'zh' ? zhCN : enUS;

ReactDOM.createRoot(document.getElementById('root')!).render(
  // StrictMode removed to prevent double-mounting issues during development
  <ConfigProvider locale={antdLocale} theme={theme}>
    <BrowserRouter>
      <AntdApp>
        <App />
      </AntdApp>
    </BrowserRouter>
  </ConfigProvider>
);
